import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { ButtonEmailRenderer } from "./email";
import { RowBlockProps } from "./types";


export function ButtonEditorRenderer(props: RowBlockProps) {
	return (
		<EmailComponentWrapper shop={props.shop}>
			<ButtonEmailRenderer isEditor {...props} />
		</EmailComponentWrapper>
	);
}
